import { z } from 'zod';

const CurrencyAndAmountSchema = z.object({
  currency: z.string(),
  amount: z.string().nullable(),
});

export const GetFiatQuotaResultSchema = z.object({
  details: z.object({
    transactionsPerDay: z.number(),
    transactionsPerMonth: z.number(),
    transactionsDailyCount: z.number(),
    transactionsMonthlyCount: z.number(),
    remainingTransactionsDailyCount: z.number(),
    remainingTransactionsMonthlyCount: z.number(),
    monthlyQuotaInUsd: CurrencyAndAmountSchema,
    dailyQuotaInUsd: CurrencyAndAmountSchema,
    usedDailyQuotaInUsd: CurrencyAndAmountSchema,
    usedMonthlyQuotaInUsd: CurrencyAndAmountSchema,
    remainingDailyQuotaInUsd: CurrencyAndAmountSchema,
    remainingMonthlyQuotaInUsd: CurrencyAndAmountSchema,
    monthlyQuota: CurrencyAndAmountSchema,
    dailyQuota: CurrencyAndAmountSchema,
    usedMonthlyQuota: CurrencyAndAmountSchema,
    usedDailyQuota: CurrencyAndAmountSchema,
    remainingMonthlyQuota: CurrencyAndAmountSchema,
    remainingDailyQuota: CurrencyAndAmountSchema,
    minimumWithdrawalAmount: CurrencyAndAmountSchema,
    currencyUsedDailyQuota: CurrencyAndAmountSchema,
    currencyUsedMonthlyQuota: CurrencyAndAmountSchema,
    currencyRemainingDailyQuota: CurrencyAndAmountSchema,
    currencyRemainingMonthlyQuota: CurrencyAndAmountSchema,
    currencyTransactionsPerDay: z.number(),
    currencyTransactionsPerMonth: z.number(),
    currencyRemainingTransactionsDailyCount: z.number(),
    currencyRemainingTransactionsMonthlyCount: z.number(),
    networkName: z.string(),
  }),
});

export type GetFiatQuotaResult = z.infer<typeof GetFiatQuotaResultSchema>;
